/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientTableSortModel = {
    sort: ClientTableSortModel.sort;
    field: string;
};
export namespace ClientTableSortModel {
    export enum sort {
        ASC = 'asc',
        DESC = 'desc',
    }
}

